export function normalizeUSPhone(number) {
  try {
    if (typeof number !== "string") {
      // Convert non-string inputs safely
      if (number === undefined || number === null) return null;
      number = String(number);
    }

    // Trim spaces
    number = number.trim();

    if (number.length === 0) return null;

    // Remove non-digits
    const digits = number.replace(/\D/g, "");

    // Extract last 10 digits
    const last10 = digits.slice(-10);

    if (last10.length !== 10) return null;

    return `+1${last10}`;
  } catch (err) {
    return null;
  }
}

export function normalizePhone(number, defaultCountryCode = "+1") {
  try {
    if (number == null) return null;

    // Ensure string + trim whitespace
    let cleaned = String(number).trim();
    if (!cleaned) return null;

    // Remove everything except digits and +
    cleaned = cleaned.replace(/[^\d+]/g, "");

    // If starts with + → treat as full international number
    if (cleaned.startsWith("+")) {
      const digitsOnly = cleaned.replace(/\D/g, "");
      // Must be 8–15 digits for valid E.164
      if (digitsOnly.length < 8 || digitsOnly.length > 15) return null;
      return `+${digitsOnly}`;
    }

    // If does NOT start with + → assume it's national number
    const digits = cleaned.replace(/\D/g, "");

    if (!digits) return null;

    // Enforce E.164 digit length (nationals typically 8–12 digits)
    if (digits.length < 6 || digits.length > 12) return null;

    // Apply default country code
    const countryDigits = defaultCountryCode.replace(/\D/g, "");

    return `+${countryDigits}${digits}`;

  } catch (err) {
    console.error("normalizePhone error:", err);
    return null;
  }
}

